(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/text-field.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/text-field.js');
'use strict';

const {
  Form
} = svs.ui.reactForm;
const {
  TextInput
} = svs.ui.reactFormInputs;
const Button = svs.ui.ReactButton;
const {
  MAX_MESSAGE_LENGTH
} = svs.arena.constants;
const TextField = _ref => {
  let {
    children,
    onSubmit = () => {},
    buttonText = 'Skicka e-post',
    label = 'Skriv meddelande',
    onHide = () => {}
  } = _ref;
  const [message, setEmail] = React.useState('');
  const handleChange = e => {
    e.stopPropagation();
    const text = e.target.value;
    if (text.length > MAX_MESSAGE_LENGTH) {
      return;
    }
    setEmail(text);
  };
  const onSubmitProcess = e => {
    onSubmit(message);
    e.preventDefault();
  };
  const handleKeyDown = e => {
    e.stopPropagation();
  };
  return React.createElement(Form, {
    method: "post",
    onSubmit: onSubmitProcess
  }, children, React.createElement("div", {
    className: "data-hj-suppress"
  }, React.createElement(TextInput, {
    infoMessage: "Antal tecken kvar : ".concat(MAX_MESSAGE_LENGTH - message.length),
    isLessSpace: true,
    label: label,
    multiline: true,
    name: "email",
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    rows: 3,
    value: message
  })), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    inverted: true,
    type: "submit"
  }, buttonText), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    onClick: onHide,
    transparent: true
  }, "Avbryt"));
};
svs.arena.pages.teams.components.TextField = TextField;

 })(window);